<template>
    <div class="need-help">
        <card headline="Brug for hjælp til din opsætning?" description="Få hjælp fra en medarbejder" icon="pe-7s-help1">
            <hr>

            <div class="row">
                <div class="col-md-8 col-md-push-2 text-center">
                    <div class="img-container center-block">
                        <img src="/images/employees/salma_elrefai.jpg" class="img-responsive">
                    </div>

                    <br>

                    <p class="text-muted">Få hjælp til at sætte dine integrationer op fra en af vores medarbejdere</p>
                </div>
            </div>
        </card>
    </div>
</template>

<style lang="scss" scoped>
    .need-help {
        .img-container {
            width: 150px;
            height: 150px;
            overflow: hidden;
            border-radius: 999px;
            border: 1px solid #dedede;

        }
    }
</style>

<script>
    import Card from '@/app/shared/components/Card'

    export default {
      components: {
        Card
      }
    }
</script>
